const BASE = '/v1/auth'

export const AUTH_ROUTES = {
  REGISTER: `${BASE}/register`,
  LOGIN_PHONE: `${BASE}/login/phone`,
  LOGIN_GOOGLE: `${BASE}/login/google`,
  REFRESH_TOKEN: `${BASE}/refresh-token`,
  LOGOUT: `${BASE}/logout`,
  RECOVERY_PASSWORD: `${BASE}/recovery-password`,
  RESEND_RECOVERY_CODE: `${BASE}/resend-recovery-code`,
  VALIDATE_RECOVERY_CODE: `${BASE}/validate-recovery-code`,
  RESET_PASSWORD: `${BASE}/reset-password`,
} as const
